<template>
  <component
    :is="component"
    :class="`theme-${theme}`"
    class="button-underline"
    v-bind="props"
  >
    <slot />
  </component>
</template>

<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router';
import type { NuxtLinkProps } from '#app';

export interface ButtonBaseProps extends NuxtLinkProps {
  theme?: string;
  disabled?: boolean;
  to?: string | RouteLocationRaw;
}

const props = defineProps({
  theme: { default: 'secondary' },
  disabled: { type: Boolean },
  to: null
});

const component = computed(() => {
  if (props.to || props.href) {
    return resolveComponent('NuxtLink');
  }
  return 'button';
});
</script>
<style lang="scss" scoped>
.button-underline {
  @include font('n', 500);

  position: relative;
  padding-bottom: 0.2rem;
  color: var(--color_secondary);
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.2rem;
    transform: scale(0);
    transition: transform 300ms $ease-in-out-quad;
    background-color: var(--color_secondary);
  }

  &:hover::after,
  &:focus::after {
    transform: scale(1);
  }
}
</style>
